import { render, staticRenderFns } from "./feature-list.vue?vue&type=template&id=fb1b4cae"
import script from "./feature-list.vue?vue&type=script&lang=js"
export * from "./feature-list.vue?vue&type=script&lang=js"
import style0 from "./feature-list.vue?vue&type=style&index=0&id=fb1b4cae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports